import { render, staticRenderFns } from "./InvoicePaymentHistory.vue?vue&type=template&id=3056f97b&scoped=true"
import script from "./InvoicePaymentHistory.vue?vue&type=script&lang=js"
export * from "./InvoicePaymentHistory.vue?vue&type=script&lang=js"
import style0 from "./InvoicePaymentHistory.vue?vue&type=style&index=0&id=3056f97b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3056f97b",
  null
  
)

export default component.exports